import React, { useState, useRef, useEffect } from 'react';
import { TopMenuItemProps } from './types';
import { SubMenuItems } from './SubMenuItems';

export const TopMenuItem: React.VFC<TopMenuItemProps> = ({ menuItem, chevronIconSvg, arrowIconSvg, isintra, pageId }) => {
  const id = `top-menu-item-${pageId}`;
  const [isSelected, setIsSelected] = useState(false);

  const ref = useRef<HTMLLIElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (isSelected && ref.current && !ref.current.contains(event.target as Node)) {
        setIsSelected(false);
      }
    };

    const handleTabOutside = (event: KeyboardEvent) => {
      if (event.key == 'Tab') {
        handleClickOutside(event);
      }
    };

    const handleEscape = (event: KeyboardEvent) => {
      if (isSelected && event.key === 'Escape' && ref.current && ref.current.contains(event.target as Node)) {
        event.stopPropagation();
        setIsSelected(false);
        buttonRef.current?.focus();
      }
    };

    if (menuItem.hasChildren) {
      document.addEventListener('click', handleClickOutside);
      document.addEventListener('keyup', handleTabOutside);
      document.addEventListener('keydown', handleEscape);
    }
    return () => {
      if (menuItem.hasChildren) {
        // Cleanup the event listener
        document.removeEventListener('click', handleClickOutside);
        document.removeEventListener('keyup', handleTabOutside);
        document.removeEventListener('keydown', handleEscape);
      }
    };
  }, [isSelected]);

  async function onTopMenuItemClick(event) {
    event.preventDefault();

    setIsSelected((prev) => !prev);
  }

  const className = `main-menu__top-item ignore-link-focus ${menuItem.isInActiveChain ? 'main-menu__top-item--selected' : ''
    } ${isSelected ? 'main-menu__top-item--open' : ''}`;

  return (
    <li ref={ref}>
      {menuItem.hasChildren ? (
        <>
          <button
            ref={buttonRef}
            className={className}
            aria-expanded={isSelected ? 'true' : 'false'}
            aria-controls={id}
            onClick={(e) => {
              onTopMenuItemClick(e);
            }}
            data-haschildren="true"
          >
            <span>{menuItem.text}</span>
            <span
              className="main-menu__chevron-icon"
              aria-hidden="true"
              dangerouslySetInnerHTML={{ __html: chevronIconSvg }}
            />
          </button>

          {isSelected && <div className="main-menu__bridge"></div>}
        </>
      ) : (
        <a className={className} href={menuItem.href}>
          {menuItem.text}
        </a>
      )}

      {menuItem.hasChildren && (
        <SubMenuItems
          isSelected={isSelected}
          menuItems={menuItem.children}
          parentItem={menuItem}
          ariaControlsId={id}
          arrowIconSvg={arrowIconSvg}
          isintra={isintra}
        />
      )}
    </li>
  );
};
